<template>
  <form action="" v-on:submit.prevent v-if="event">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Match Result</p>
      </header>
      <section class="modal-card-body">
        <Entry :entry="entry1()" :event="event" :tournament="tournament" />
        <b-field label="">
          <b-input
                  type="text"
                  v-model="score1"
                  placeholder="Score"
                  required>
          </b-input>
        </b-field>

        <Entry :entry="entry2()" :event="event" :tournament="tournament" />
        <b-field label="">
          <b-input
                  type="text"
                  v-model="score2"
                  placeholder="Score"
                  required>
          </b-input>
        </b-field>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-danger" type="button" @click="clearScore">Clear</button>
        <button class="button is-primary" @click="submitScore">Submit</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Entry from "./Entry.vue";
import axios from '../request.js';

export default {
  name: 'MatchResultForm',
  props: {
    match: Object,
    event: Object,
    tournament: Object
  },

  data: function() {
    return {
      score1: 0,
      score2: 0
    }
  },

  created: function(){
    if (this.match && this.match.entry1 && this.match.entry2) {
      this.score1 = 0;
      this.score2 = 0;


      if (this.match.result) {
        this.score1 = this.match.result[this.match.entry1];
        this.score2 = this.match.result[this.match.entry2];
      }
    }
  },

  methods: {
    entry1() {
      return this.event.entry[this.match.entry1];
    },

    entry2() {
      return this.event.entry[this.match.entry2];
    },


    clearScore() {

      let vm = this;
      let tournamentId = this.tournament.id;
      let eventId = this.event.id;

      axios.post('/api/tournament/' + tournamentId + '/event/' + eventId + '/match?clear=true', {
        id: this.match.id
      })
              .then(function(response){
                vm.$store.dispatch('tournamentEventsChanged', { tournamentId: tournamentId, events: response.data, stayOnPage: true });
                vm.$parent.close();
              })
              .catch(function(){
                vm.$parent.close();
              });
    },


    submitScore() {

      if (isNaN(this.score1) || isNaN(this.score2) || this.score1 == this.score2) {
        this.$parent.close();
        return /* wrong */;
      }

      let score1 = parseInt(this.score1, 10);
      let score2 = parseInt(this.score2, 10);

      if ([0, 1, 2].indexOf(score1) < 0 || [0, 1, 2].indexOf(score2) < 0) {
        this.$parent.close();
        return /* wrong */;
      }

      let vm = this;
      let tournamentId = this.tournament.id;
      let eventId = this.event.id;

      axios.post('/api/tournament/' + tournamentId + '/event/' + eventId + '/match', {
        id: this.match.id,

        result: {
          [this.entry1().id]: score1,
          [this.entry2().id]: score2,

          winner: (score1 > score2) ? (this.entry1().id) : (this.entry2().id)
        }
      })
              .then(function(response){
                vm.$store.dispatch('tournamentEventsChanged', { tournamentId: tournamentId, events: response.data, stayOnPage: true });
                vm.$parent.close();
              })
              .catch(function(){
                vm.$parent.close();
              });


    }
  },

  components: { Entry }
}
</script>

<style scoped>

</style>
